import React from "react";
import useTransitionStore from "../../../state/transitions";
import useCustomizerStore from "../../../state/customizer";
import { defaultControlAngles } from "../../../util/defaultControlAngles";

const PowertrainBtn = ({ mode, setDelay }) => {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const setDisplayMode = useTransitionStore((s) => s.setDisplayMode);
  const setModelInHeader = useTransitionStore((s) => s.setModelInHeader);
  const setCamIndex = useTransitionStore((s) => s.setCamIndex);
  const setSelectedHotspot = useCustomizerStore((s) => s.setSelectedHotspot);
  const setFilterHotspots = useCustomizerStore((s) => s.setFilterHotspots);
  const filterHotspots = useCustomizerStore((s) => s.filterHotspots);
  const setDayMode = useTransitionStore((s) => s.setDayMode);
  const HotspotControls = useTransitionStore((s) => s.HotspotControls);
  const setHotspotZoomed = useTransitionStore((s) => s.setHotspotZoomed);
  const setHotspotControls = useTransitionStore((s) => s.setHotspotControls);
  const setAzimuthAndPolarAnglesNeedUpdate = useTransitionStore(
    (s) => s.setAzimuthAndPolarAnglesNeedUpdate
  );
  const setTempAzimuthAndPolarAngles = useTransitionStore(
    (s) => s.setTempAzimuthAndPolarAngles
  );
  const setSuspensionMode = useTransitionStore((s) => s.setSuspensionMode);

  return (
    <button
      style={{
        background: DisplayMode === "powertrain" ? "#EB0A1E" : "#FFF",
        color: DisplayMode === "powertrain" ? "#fff" : "#000",
        fontWeight: "600",
        marginRight: 0,
      }}
      className="powertrain"
      onClick={() => {
        mode.current = "powertrain";
        setCamIndex(4);
        setModelInHeader(true);
        setDayMode("night");
        if (DisplayMode == "interior") {
          setTempAzimuthAndPolarAngles(defaultControlAngles);
          setAzimuthAndPolarAnglesNeedUpdate(true);
        }
        setDisplayMode("powertrain");
        setDelay(100);
        setSelectedHotspot("");
        setSuspensionMode(false);
        if (filterHotspots) setFilterHotspots(false);
        if (HotspotControls) {
          setHotspotControls(false);
          setTempAzimuthAndPolarAngles(defaultControlAngles);
          setAzimuthAndPolarAnglesNeedUpdate(true);
          setHotspotZoomed(false);
        }
      }}
    >
      Powertrain
    </button>
  );
};

export default React.memo(PowertrainBtn);
